// extracted by mini-css-extract-plugin
module.exports = {"status":"VendorAnalyticsSales_status__1QMWv"};